import { render, staticRenderFns } from "./translate-type.vue?vue&type=template&id=5af856b0"
import script from "./translate-type.vue?vue&type=script&lang=js"
export * from "./translate-type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports